import { MutationTree } from "vuex";
import { TradeContractState, TradeContract } from "./model";

const mutations: MutationTree<TradeContractState> = {
  setRequestingTradeContracts(state, tradeContracts: TradeContract[]) {
    state.requestingTradeContracts = tradeContracts
  },
  setTradingTradeContracts(state, tradeContracts: TradeContract[]) {
    state.tradingTradeContracts = tradeContracts
  },
  setTradeContract(state, tradeContract: TradeContract) {
    state.tradeContract = tradeContract
  },
  addTradingTradeContract(state, tradeContract: TradeContract) {
    state.requestingTradeContracts.push(tradeContract)
  },
  deleteRequestingTradeContracts(state, tradeContractId: string) {
    state.requestingTradeContracts = state.requestingTradeContracts.filter(tc => tc.id !== tradeContractId);
  },
}

export default mutations;
